import { defineConfig } from '@chakra-ui/react';
import { createAybleSystem } from '@ayble-health/dashboard-components/theme';

/**
 * Shared Ayble tokens live in `@ayble-health/dashboard-components/theme`.
 * This file re-exports them so existing `from './theme/chakra'` imports
 * keep working, and layers on dashboard-only color names still referenced
 * by ProviderHome (`ink`, `subtle`) plus `merlot` for parity with the
 * previous local theme.
 */
export {
  brand,
  legacyPalettes,
  accents,
  fontTokens,
  fontSizeTokens,
  fontWeightTokens,
  lineHeightTokens,
  breakpointTokens,
  semanticColorTokens,
  aybleThemeConfig,
} from '@ayble-health/dashboard-components/theme';

const dashboardExtras = defineConfig({
  theme: {
    tokens: {
      colors: {
        ink: { value: '#20262A' },
        subtle: { value: '#8B9298' },
        merlot: { value: '#4E152E' },
      },
    },
  },
});

export const designSystem = createAybleSystem(dashboardExtras);
